// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1m80B","content":"RecentSearches_content__thnTb"};